var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterUsedPerWash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "url(#paint0_linear_5070_17882)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4952 23.8057L33.9926 26.303L35.7602 24.5354V17.4648H28.6896L26.922 19.2324L28.9201 21.2306L29.412 21.7225L25.816 25.3185L21.635 21.1376L20.5934 20.096L19.5518 21.1376L12.2402 28.4491L14.3234 30.5324L20.5934 24.2624L24.7744 28.4433L25.816 29.4849L26.8575 28.4433L31.4952 23.8057Z",
    fill: "url(#paint1_linear_5070_17882)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5070_17882",
    x1: 48,
    y1: 48,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F13741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4929E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5070_17882",
    x1: 24.0002,
    y1: 17.4648,
    x2: 24.0002,
    y2: 30.5324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterUsedPerWash);
export default __webpack_public_path__ + "static/media/water-used-per-wash.211b6618a53c5b82a28e283a4db3a303.svg";
export { ForwardRef as ReactComponent };